export default __webpack_public_path__ + "static/milestone-b9efa89b1a9769f2aabff2f3b0799684.png";